
class ModelItemView {
	constructor (opts = {type: "text"}) {
		this.name = opts.name || opts.model || opts.key;
		this.key = opts.key;
		this.model = opts.model;
		this.label = opts.label;
		this.title = opts.title;
		this.type = opts.type;
		this.viewAttrs = Object.assign({}, opts.attrs, opts.viewAttrs);
		this.editAttrs = Object.assign({}, opts.attrs, opts.editAttrs);
		this.exec = opts.exec;
		if (opts.subgroup && opts.subgroup.map) {
			this.subgroup = opts.subgroup.map( item => new ModelItemView(item) );
		}
	}

	value (entity, index) {

		if (index === undefined) {

			if (this.model) {

				return entity.data[this.model];

			} else if (this.subgroup) {

				return new ModelTableView(this.subgroup);

			} else if (this.exec instanceof Function) {

				return this.exec(entity);

			} else if (this.key) {

				if (entity.computed[this.key] instanceof Function) {

					delete arguments[0];
					return entity.computed[this.key](...arguments);

				} else if (this.key in entity) {

					return entity[this.key];

				}
			}
		} else {

			return this.value(entity)[index];

		}
	}
};

class ModelTableView {
	constructor (items) {
		this.props = [];
		for (let item of items) {
			const prop = item instanceof ModelItemView ?
				item :
				new ModelItemView(item);
			this.props.push(prop);
		}
	}

	setVisibility (state, items) {
		for (let prop of this.props) {
			if (items.some( item => prop === item || prop.name == item )) {
				prop.isVisible = !!state;
			}
		}
	}

	visibleProperties (items) {
		if (items) {
			this.setVisibility(true, items);
		} else {
			return this.props.filter(prop => prop.isVisible);
		}
	}

	hiddenProperties (items) {
		if (items) {
			this.setVisibility(false, items);
		} else {
			return this.props.filter(prop => !prop.isVisible);
		}
	}

	values (entity, props) {
		return Array.isArray(entity) ?
			entity.map( e => this.values(e, props) ) :
			(props || this.props).map( prop => prop.value(entity) );
	}

	sortBy (item, isDescending) {
		this.sortName = item instanceof ModelItemView
			? item.name
			: item;

		this.sortDescending = isDescending;
	}
}

export {
	ModelItemView,
	ModelTableView
};



// WEBPACK FOOTER //
// ./src/assets/js/ModelView.js